import { Outlet, useLoaderData } from "@remix-run/react";
import Footer from "../components/Footer";
import Header from "../components/header";
import { json } from "@remix-run/node";
import { getSupabaseWithSessionHeaders } from "../lib/supabase_server";
import { type LoaderFunctionArgs } from "@remix-run/node";
import {
  getSessionUser,
  redirectOnIncompleteOnBoarding,
} from "../lib/onboarding.server";

export const loader = async ({ request }: LoaderFunctionArgs) => {
  const { headers, supabase, session } = await getSupabaseWithSessionHeaders({
    request,
  });
  const requestUrl = new URL(request.url);
  const redirectTo = `${requestUrl.pathname}${requestUrl.search}`;
  if (!session) {
    //TODO: this means that one cannot access the store page if they don't have an account 
    // return redirect("/login", { headers }); 
    return json({ userDetails: null }, { headers });
  }
  const user = await getSessionUser({
    session,
    supabase,
  });
  const onboardingRedirect = redirectOnIncompleteOnBoarding({
    user,
    headers,
    redirectTo,
  });
  if (onboardingRedirect) {
    return onboardingRedirect.response;
  }
 
  return json({ userDetails: { ...user } }, { headers });
};

export default function StoreRoute() {
  const { userDetails } = useLoaderData<typeof loader>();

  return (
    <div className="flex flex-col min-h-screen">
      <Header
        userId={userDetails?.id || ""}
        userName={userDetails?.first_name || ""}
        isAdmin={Boolean(userDetails?.admin)}
      />
      <main className="flex flex-1 flex-col">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
